<section class="report">
  <div class="report_page" [ngClass]="{ 'mobile-live-layout': displayedContent === 'mobileLive' }">
    <div class="left_page" id="left_page">
      <div class="left_page_top">
        <div class="left_page_top_searchbar">
          <input type="search" placeholder="Search" (click)="showDiv = !showDiv" [(ngModel)]="searchText"
            (keyup.enter)="searchFilter()">
          <div class="search_filter" id="hiddenDiv" *ngIf="showDiv">
            <div class="filter_btn_top">
              <button class="filter_btn" #sortBtn (click)="showsortDiv = !showsortDiv"><mat-icon
                  class="custom-icon-class filter_icon center">swap_vert</mat-icon>
                <div class="center">Sort</div>
                <div class="sort_filter" #sortDiv id="hiddenDiv" *ngIf="showsortDiv">
                  <button class="filter_btn" (click)="setSortingDirection('desc')">Newest First</button>
                  <button class="filter_btn" (click)="setSortingDirection('asc')">Oldest First</button>
                </div>
              </button>
              <button class="filter_btn1" (click)="changeColor()" [style.background]="activeButtonColor"><mat-icon
                  class="down-arrow filter_icon center"><span>sort_by_alpha</span></mat-icon>
                <div class="center">Title only</div>
              </button>
              <button class="filter_btn1" *ngIf="activeBtn === 'exe'" (click)="changeScheduledColor()"
                [style.background]="activeScheduledButtonColor"
                matTooltip="Show only scheduled and library executions">
                <mat-icon class="down-arrow filter_icon center">
                  <span>event_repeat</span>
                </mat-icon>
                <div class="center">Scheduled</div>
              </button>
              <button #createdBtn class="filter_btn" (click)="showCreated()"><mat-icon
                  class="down-arrow filter_icon center"><span>person</span></mat-icon>
                <div class="filter_icon_name">Created by</div><mat-icon
                  class="down-arrow filter_icon center"><span>keyboard_arrow_down</span></mat-icon>

              </button>
              <div #createdDiv class="name_filter" id="hiddenDiv"
                *ngIf="usernames && usernames.length > 0 && showCreatedDiv">
                <input type="text" placeholder="Search" [(ngModel)]="searchCreatedTerm" (input)="updateCreatedFilter()">
                <ul>
                  <li *ngFor="let username of usernames" [class.selected]="selectedCreatedUsers[username]"
                    (click)="toggleCreateSelection(username)">
                    <span class="selectable-name">{{ username
                      }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="filter_btn_bottom">
              <button #executedBtn class="filter_btn" (click)="showExecuted()"><mat-icon
                  class="down-arrow filter_icon center"><span>person</span></mat-icon>
                <div class="filter_icon_name">Executed by</div><mat-icon
                  class="down-arrow filter_icon center"><span>keyboard_arrow_down</span></mat-icon>

              </button>
              <div #executedDiv class="name_filter" id="hiddenDiv"
                *ngIf="usernames && usernames.length > 0 && showExecutedDiv">
                <input type="text" placeholder="Search" [(ngModel)]="searchExecutedTerm" (input)="updateFilter()">
                <ul>
                  <li *ngFor="let username of usernames" [class.selected]="selectedExecutedUsers[username]"
                    (click)="toggleExecuteSelection(username)">
                    <span class="selectable-name">{{ username
                      }}</span>
                  </li>
                </ul>
              </div>
              <button #artifactBtn class="filter_btn" (click)="showArtifacts()"><mat-icon
                  class="down-arrow filter_icon center">
                  insert_drive_file</mat-icon>
                <div class="filter_icon_name">Test Artifacts</div><mat-icon
                  class="down-arrow filter_icon center"><span>keyboard_arrow_down</span></mat-icon>
              </button>
              <div #artifactDiv class="name_filter" id="hiddenDiv" *ngIf="showArtifact">
                <ul>
                  <li *ngFor="let artifact of artifacts" [class.selected]="selectedArtifact[artifact]"
                    (click)="toggleArtifactSelection(artifact)">
                    <span class="selectable-name">{{ artifact }}</span>
                  </li>
                </ul>
              </div>
              <button #dateBtn class="filter_btn" (click)="openDatePicker()"><mat-icon
                  class="down-arrow filter_icon center">
                  insert_invitation</mat-icon>
                <div class="filter_icon_name">Date</div><mat-icon
                  class="down-arrow filter_icon center"><span>keyboard_arrow_down</span></mat-icon>
              </button>
              <div #dateDiv *ngIf="showDatePickers" class="name_filter">
                <button (click)="getLast7Days()">Last 7 days</button>
                <button (click)="getLast30Days()">Last 30 days</button>
                <button (click)="getLast90Days()">Last 90 days</button>
                <mat-form-field>

                  <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="startDate">
                  <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #startDatePicker></mat-datepicker>
                </mat-form-field>

                <mat-form-field>
                  <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="endDate">
                  <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #endDatePicker (dateChange)="onDateChanged($event)"></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="btnOpt">
                <button class="apply_right_button" matTooltip="Apply Filter" *ngIf="showDiv"
                  (click)="applyFilter()">✓</button>
                <button matTooltip="Reset Filters" (click)="resetFilters()">↻</button>
              </div>
            </div>
          </div>
        </div>
        <div class="left_page_top_btn">
          <button class="btn_new" (click)="switch('exe')" matTooltip="Library Execution List"
            [ngClass]="{'active': activeBtn === 'exe'}">Library</button>
          <button class="btn_new" (click)="switch('ide')" matTooltip="Canvas Execution List"
            [ngClass]="{'active': activeBtn === 'ide'}">Canvas</button>
          <ng-container *featureVisible="'SCHEDULER'">
            <button class="btn_new" (click)="switch('schedule')" matTooltip="Scheduled Execution List"
              [ngClass]="{'active': activeBtn === 'schedule'}" [featureNavState]="'SCHEDULER'" [showBadge]="false">Schedule</button>
          </ng-container>
        </div>
      </div>
      <div class="left_page_selected_report" *ngIf="!noExecutions">
        <li class="single_report currentReport"
          [ngClass]="{'triggered' :currentReport?.run_status_text==null,'starting' :(currentReport?.run_status_text=='STITCH_FRAMEWORK' || currentReport?.run_status_text=='DEPLOY_FRAMEWORK'||currentReport?.run_status_text=='GENERATING_CODE'),'progress' :currentReport?.run_status_text=='EXECUTE_FRAMEWORK','completed' :currentReport?.run_status_text=='Completed','failed' :(currentReport?.run_status_text=='Failed' || currentReport.run_status_text === 'Execution Failed')}">
          <div class="paddingonly">
            <div class="single_report_top" *ngIf="currentReport?._id">
              <div class="single_report_top_left">
                <div>{{currentReport?.suite?.name}} | {{currentReport?.created_by}}</div>
                <div id="report-user-time"
                  *ngIf="currentReport?.start_time && currentReport?.start_time!=0; else showMessage">
                  {{currentReport?.start_time | date:'MMM d, yyyy, h:mm:ss a'}} |
                  <span *ngIf="currentReport?._id">
                    {{ getStatusText(currentReport?.run_status_text) }}
                  </span>
                </div>
                <ng-template #showMessage><span id="report-status">Not Started</span></ng-template>
              </div>
              <div class="single_report_top_right right">
                <mat-icon class="mat_btn stop_btn" (click)="stopExecution($event, currentReport)" matTooltip="Stop"
                  [ngClass]="{ 'disabled': (currentReport.run_status_text==='Aborting' || currentReport.run_status_text==='Aborted') }">stop</mat-icon>
                <!-- <mat-icon class="mat_btn refresh_btn" matTooltip="Refresh">replay</mat-icon> -->
                <mat-icon class="mat_btn replay_btn" (click)="rerunExecution($event, currentReport)" matTooltip="Replay"
                  [ngClass]="{ 'disabled': (currentReport.run_status_text==='Aborting' || currentReport.run_status_text== null || currentReport?.run_status_text=='EXECUTE_FRAMEWORK' || currentReport?.run_status_text=='STITCH_FRAMEWORK' || currentReport?.run_status_text=='DEPLOY_FRAMEWORK'||currentReport?.run_status_text=='GENERATING_CODE') }">play_circle_outline</mat-icon>

              </div>
            </div>
            <div class="no_selected_report" *ngIf="!currentReport?._id">
            </div>
            <mat-progress-bar class="progressbar" mode="determinate"></mat-progress-bar>
          </div>
        </li>
      </div>
      <div class="left_page_middle" *ngIf="!noExecutions">
        <ul class="single_repo">
          <li class="single_report" (click)="getSelectedReportData(report._id)"
            *ngFor="let report of filterList; let i = index"
            [ngClass]="{'selectedReport':report._id==currentReport?._id, 'triggered' :report?.run_status_text==null, 'starting' :(report?.run_status_text=='STITCH_FRAMEWORK' || report?.run_status_text=='DEPLOY_FRAMEWORK'||report?.run_status_text=='GENERATING_CODE'),'progress' :report?.run_status_text=='EXECUTE_FRAMEWORK','completed' :report?.run_status_text=='Completed','failed' :(report?.run_status_text=='Failed' || report?.run_status_text == 'Execution Failed')}">
            <div class="paddingonly">
              <div class="single_report_top">
                <div class="single_report_top_left">
                  <div class="report-name-row">
                    <span>{{report?.suite?.name}} | {{report?.created_by}}</span>
                  </div>
                  <div id="report-user-time" *ngIf="report?.start_time!=0; else showMessage">
                    {{report?.start_time | date:'MMM d, yyyy, h:mm:ss a'}} | {{report.start}}
                    <span>
                      {{ getStatusText(report?.run_status_text) }}
                    </span>
                  </div>
                  <ng-template #showMessage><span id="report-status">Not Started</span></ng-template>
                </div>
                <div class="single_report_top_right right">
                  <mat-icon class="mat_btn stop_btn" (click)="stopExecution($event, report)" matTooltip="Stop"
                    [ngClass]="{ 'disabled': (report.run_status_text==='Aborting' || report.run_status_text==='Aborted') }">stop</mat-icon>
                  <!-- <mat-icon class="mat_btn refresh_btn" matTooltip="Refresh">replay</mat-icon> -->
                  <mat-icon class="mat_btn delete_btn" *ngIf="user?.endsWith('@icodetest.com')"
                    (click)="deleteReport($event, report)" matTooltip="Delete"
                    [ngClass]="{ 'disabled': (report.run_status_text==='Deleting') }">delete</mat-icon>
                  <mat-icon class="mat_btn replay_btn" (click)="rerunExecution($event, report)" matTooltip="Replay"
                    [ngClass]="{ 'disabled': (report.run_status_text==='Aborting' || report.run_status_text== null || report?.run_status_text=='STITCH_FRAMEWORK' || report?.run_status_text=='EXECUTE_FRAMEWORK' || report?.run_status_text=='DEPLOY_FRAMEWORK'||report?.run_status_text=='GENERATING_CODE') }">play_circle_outline</mat-icon>
                  <ng-container *featureVisible="'AI_TESTCASE_GENERATION'">
                    <mat-icon class="mat_btn delete_btn"
                      *ngIf="activeBtn === 'exe' && report?._id == currentReport?._id && report?.run_status_text === 'Completed' && report?.end_time != 0"
                      (click)="openGenerateTestCase($event, report)"
                      matTooltip="Generate Test Case"
                      [featureNavState]="'AI_TESTCASE_GENERATION'" [showBadge]="false">playlist_add</mat-icon>
                  </ng-container>
                </div>
              </div>
              <mat-progress-bar class="progressbar" mode="determinate"></mat-progress-bar>
            </div>
          </li>
        </ul>
      </div>
      <div class="left_page_bottom center" *ngIf="!noExecutions">
        <ze-pagination *ngIf="paginationPage && totalPages > 1" [pageDetails]="paginationPage"
          (gotoPage)="onChangePage($event)"></ze-pagination>
      </div>
      <div class="left_page_no_exec" *ngIf="noExecutions">
        <div class="no_exec_msg">
         <ng-container *ngIf="activeBtn === 'schedule'; else defaultEmptyMsg">
            <mat-icon class="no-exec-schedule-icon">event_busy</mat-icon>
            <h3>No Scheduled Executions:</h3>
            <span>No scheduled suite runs found for this project.</span>
          </ng-container>
          <ng-template #defaultEmptyMsg>
            <h3>Empty Execution:</h3>
            <span>No executed suite identified. Ready to launch a new one?</span>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="right_page" id="right_page">
      <ng-container *ngIf="!currentReportLoading">
        <div *ngIf="currentReportLoadFailed" class="current_report_load_failed">
          <img src="../../../assets/images/error-cross.png" alt="Error" class="alert-image">
          <h3>Error in loading report. retry loading again...</h3>
          <mat-icon class="mat_btn" (click)="getSelectedReportData(currentReport._id)"
            matTooltip="Retry">refresh</mat-icon>
        </div>

        <div class="right_page_top">
          <div class="right_page_top_block">
            <div class="top_btn_top_row">
              <div class="top_btn_top_row_left">
                <div>
                  <ul class="top_btn">
                    <li class="btn"
                      *ngIf="(currentReport.run_status_text === 'Completed' || currentReport.run_status_text === 'Failed'|| currentReport.run_status_text === 'Execution Failed') && hasLiveStatus(currentReport.report_links)"
                      (click)="showContent('statistic')" [ngClass]="{'active': activeContent === 'statistic'}">STATISTIC
                    </li>
                    <li class="btn"
                      *ngIf="(currentReport.run_status_text === 'EXECUTE_FRAMEWORK' || currentReport.run_status_text === 'Completed' || currentReport.run_status_text === 'Aborted' || currentReport.run_status_text === 'Failed'|| currentReport.run_status_text === 'Execution Failed') && hasLiveStatus(currentReport.report_links) && selectedBrowser != '' && selectedIteration != ''"
                      (click)="showContent('stepexecution')" [ngClass]="{'active': activeContent === 'stepexecution'}">
                      STEPWISE
                    </li>
                    <li class="btn"
                      *ngIf="currentReport.run_status_text === 'EXECUTE_FRAMEWORK' && hasSelenoidLink(currentReport.report_links) && selectedBrowser != '' && selectedIteration != ''"
                      (click)="showContent('live')" [ngClass]="{'active': activeContent === 'live'}">WEB LIVE</li>
                    <li class="btn"
                      *ngIf="currentReport.run_status_text === 'EXECUTE_FRAMEWORK' && hasAppiumLink(currentReport.report_links)"
                      (click)="showContent('mobileLive')" [ngClass]="{'active': activeContent === 'mobileLive'}">MOBILE
                      LIVE
                    </li>
                    <li class="btn"
                      *ngIf="currentReport.run_status_text === 'EXECUTE_FRAMEWORK' && displayedContent === 'live' && hasSecondSession() && selectedBrowser != '' && selectedIteration != ''"
                      (click)="switchSession(1)" [ngClass]="{'active': activeSession === 1}">WINDOW 1</li>
                    <li class="btn"
                      *ngIf="currentReport.run_status_text === 'EXECUTE_FRAMEWORK' && displayedContent === 'live' && hasSecondSession() && selectedBrowser != '' && selectedIteration != ''"
                      (click)="switchSession(2)" [ngClass]="{'active': activeSession === 2}">WINDOW 2</li>
                    <li class="btn"
                      *ngIf="(currentReport.run_status_text === 'Completed' || currentReport.run_status_text === 'Aborted' || currentReport.run_status_text === 'Failed'|| currentReport.run_status_text === 'Execution Failed') && hasVideoLink(currentReport.report_links) && selectedBrowser != '' && selectedIteration != ''"
                      (click)="showContent('video')" [ngClass]="{'active': activeContent === 'video'}">VIDEO</li>
                    <li class="btn"
                      *ngIf="displayedContent === 'video' && hasSecondVideo() && selectedBrowser != '' && selectedIteration != ''"
                      (click)="switchVideoSession(1)" [ngClass]="{'active': activeVideoSession === 1}">WINDOW 1</li>
                    <li class="btn"
                      *ngIf="displayedContent === 'video' && hasSecondVideo() && selectedBrowser != '' && selectedIteration != ''"
                      (click)="switchVideoSession(2)" [ngClass]="{'active': activeVideoSession === 2}">WINDOW 2</li>
                    <li class="btn largebtn"
                      *ngIf="currentReport.run_status_text === 'Completed' && currentReport.screenshot_required && selectedBrowser != '' && selectedIteration != ''"
                      (click)="showContent('visualcomparison')"
                      [ngClass]="{'active': activeContent === 'visualcomparison'}">VISUAL COMPARISON</li>
                  </ul>
                </div>
                <div class="top_btn_dropdown" *ngIf="isDropdownVisible">
                  <div *ngIf="currentReport?.report_links?.links">
                    <select name="browser" id="browser" (change)="onChangeBrowser($event)" [(ngModel)]="selectedBrowser"
                      [disabled]="isDropdownDisabled">
                      <ng-container
                        *ngIf="currentReport.run_status_text === 'EXECUTE_FRAMEWORK' && displayedContent === 'stepexecution'">
                        <option *ngFor="let browserKey of objectKeys(stepExecBrowserKeys)" [value]="browserKey">{{
                          browserKey }}
                        </option>
                      </ng-container>
                      <ng-container
                        *ngIf="currentReport.run_status_text !== 'EXECUTE_FRAMEWORK' || displayedContent != 'stepexecution'">
                        <option *ngFor="let browserKey of objectKeys(currentReport.report_links.links)"
                          [value]="browserKey">{{ browserKey }}
                        </option>
                      </ng-container>
                    </select>
                  </div>
                  <div *ngIf="currentReport?.report_links?.links">
                    <select name="iteration" id="iteration" (change)="onChangeIteration($event)"
                      [(ngModel)]="selectedIteration" *ngIf="iterationOptions.length > 1"
                      [disabled]="isDropdownDisabled">
                      <ng-container
                        *ngIf="currentReport.run_status_text === 'EXECUTE_FRAMEWORK' && displayedContent === 'stepexecution'">
                        <option *ngFor="let option of stepExecBrowserKeys[selectedBrowser]" [value]="option">{{ option
                          }}
                        </option>
                      </ng-container>
                      <ng-container
                        *ngIf="currentReport.run_status_text !== 'EXECUTE_FRAMEWORK' || displayedContent !== 'stepexecution'">
                        <option *ngFor="let option of iterationOptions" [value]="option">{{ option }}</option>
                      </ng-container>
                    </select>
                  </div>
                  <div class="step-reset-container"
                    *ngIf="currentReport.run_status_text === 'EXECUTE_FRAMEWORK' && stepSelected && (selectedBrowser !== lastStepInProgressBrowser || selectedIteration !== lastStepInProgressIteration)">
                    <mat-icon class="mat_btn step_reset_btn" (click)="resetStepExe()"
                      matTooltip="Reset">replay</mat-icon>
                  </div>
                </div>
              </div>
              <div class="top_btn_top_row_right">
                <mat-icon class="share-icon"
                  *ngIf="displayedContent === 'video' && currentReport?.report_links?.links && video_url !== null"
                  (click)="openShareUrlPopup()" matTooltip="Share Video Url">share</mat-icon>
                <ng-container *ngIf="datasetAvailable">
                  <a (click)="downloadFile()">dataset</a>
                </ng-container>
                <!-- <a (click)="downloadFile()">dataset</a> -->
                <!-- <a *ngIf="currentReport.run_status_text === 'EXECUTE_FRAMEWORK'" href="{{currentReport?.report_links?.logs_report}}" target="_blank">log</a>               -->
                <!-- <a *ngIf="currentReport.run_status_text === 'EXECUTE_FRAMEWORK'" (click)="showLog()">log</a> -->
                <a *ngIf="currentReport.run_status_text === 'Completed' || currentReport.run_status_text === 'Failed' || currentReport.run_status_text === 'Execution Failed'"
                  (click)="downloadLog()">log</a>
                <a *ngIf="(currentReport.run_status_text === 'Failed' || currentReport.run_status_text === 'Execution Failed') && isProjectManagementIntegrated && isProjectMapped && isUserQa"
                  (click)="displayRaiseBugComponent()">
                  ReportIt
                </a>

                <!-- Modal Overlay -->
                <div class="modal-overlay" *ngIf="showRaiseBug">
                  <div class="modal-content" (click)="$event.stopPropagation()">
                    <button class="close-btn" (click)="closeRaiseBugComponent()">X</button>
                    <ze-raise-bug [reportId]="currentReport._id" (bugSubmitted)="closeRaiseBugComponent()"></ze-raise-bug>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="right_page_middle">
          <ul class="right_page_middle_main">
            <li class="right_page_middle_report"
              *ngIf="(currentReport.run_status_text === 'Completed' || currentReport.run_status_text === 'Failed'|| currentReport.run_status_text === 'Execution Failed') && displayedContent === 'statistic' && hasLiveStatus(currentReport.report_links)">
              <ze-html id="html_report" *ngIf="currentReport?.report_links?.live_status" [report]=currentReport
                (changetoStepwise)="onChangeToStepwise($event)"></ze-html>
            </li>
            <li class="right_page_middle_report"
              *ngIf="(currentReport.run_status_text === 'EXECUTE_FRAMEWORK' || currentReport.run_status_text === 'Completed' || currentReport.run_status_text === 'Aborted' || currentReport.run_status_text === 'Failed'|| currentReport.run_status_text === 'Execution Failed') && displayedContent === 'stepexecution' && hasLiveStatus(currentReport.report_links) && selectedBrowser != '' && selectedIteration != ''">
              <ze-stepwise id="stepexecution"
                *ngIf="stepwiseReport?.report_links?.live_status && selectedBrowser != '' && selectedIteration != '' && isBrowserIterationDataAvailable"
                [statusModel]=stepwiseReport.report_links.live_status[selectedBrowser][selectedIteration]
                [expandStep]="stepNumberOpened" [reportStatus]="stepwiseReport.run_status_text"
                [reportId]="stepwiseReport._id" [browser]="selectedBrowser" [iteration]="selectedIteration"
                [isDb2]="viewtype == 'ide'"></ze-stepwise>
              <div class="loader-container"
                *ngIf="stepwiseReport?.report_links?.live_status && selectedBrowser != '' && selectedIteration != '' && !isBrowserIterationDataAvailable">
                <div class="report-loader"></div>
              </div>
              <div class="loader-container"
                *ngIf="selectedBrowser === '' || selectedIteration === '' || !stepwiseReport?.report_links?.live_status">
                <!-- <div class="report-loader"></div>
                Progressing... -->
                Please wait while we managing/ building the infra....
              </div>
            </li>
            <li class="right_page_middle_report"
              *ngIf="currentReport.run_status_text === 'Completed' && displayedContent === 'visualcomparison' && currentReport.screenshot_required && selectedBrowser != '' && selectedIteration != ''">
              <ze-visual-comparison id="stepexecution"
                *ngIf="stepwiseReport?.report_links?.live_status && selectedBrowser != '' && selectedIteration != ''"
                [statusModel]=stepwiseReport.report_links.live_status[selectedBrowser][selectedIteration]
                [expandStep]="stepNumberOpened" [reportStatus]="stepwiseReport.run_status_text"
                [reportId]="stepwiseReport._id" [browser]="selectedBrowser" [isDb2]="viewtype == 'ide'"
                [iteration]="selectedIteration"></ze-visual-comparison>
            </li>
            <li class="right_page_middle_report"
              *ngIf="(currentReport.run_status_text === 'EXECUTE_FRAMEWORK') && displayedContent === 'live'">
              <div id="live" *ngIf="currentReport?.report_links?.links">
                <div class="live-container-fullscreen">

                  <!-- Primary Session (Session 1) -->
                  <div class="live-session-wrapper" [class.hidden]="hasSecondSession() && activeSession !== 1">
                    <mat-icon class="mat_btn lock_unlock_btn" (click)="lockUnlockScreen()"
                      matTooltip="Lock/Unlock Screen">{{ locked ? 'lock' : 'lock_open' }}</mat-icon>
                    <div class="live-screen" id="screen"></div>
                  </div>

                  <!-- Secondary Session (Session 2) -->
                  <div class="live-session-wrapper" *ngIf="hasSecondSession()" [class.hidden]="activeSession !== 2">
                    <mat-icon class="mat_btn lock_unlock_btn" (click)="lockUnlockScreen2()"
                      matTooltip="Lock/Unlock Screen">{{ locked2 ? 'lock' : 'lock_open' }}</mat-icon>
                    <div class="live-screen" id="screen2"></div>
                  </div>

                </div>
              </div>
            </li>

            <li class="right_page_middle_report" *ngIf="(currentReport.run_status_text === 'EXECUTE_FRAMEWORK') && displayedContent === 'mobileLive' ">
              <div class="live-session-wrapper" [class.hidden]="hasSecondSession() && activeSession !== 1">
                <mat-icon class="mat_btn lock_unlock_btn" (click)="lockUnlockScreenMobile()"
                  matTooltip="Lock/Unlock Screen">{{ mobileLocked ? 'lock' : 'lock_open' }}</mat-icon>
              </div>
              <ze-mobile-stream-view #mobileStream [wsUrl]="appium_stream_url"></ze-mobile-stream-view>
            </li>

            <li class="right_page_middle_report"
              *ngIf="displayedContent === 'video' && currentReport?.report_links?.links">
              <div id="video-display" class="video-container-fullscreen">

                <!-- Primary Video (Video 1) -->
                <div class="video-session-wrapper" *ngIf="!hasSecondVideo() || activeVideoSession === 1">
                  <ze-video id="video" *ngIf="video_url !== null" [filename]="video_url" [videoContent]="true"
                    [username]="user">
                  </ze-video>
                  <div class="loader-container" *ngIf="video_url == null && !videoNotFound && !updatingVideoUrl">
                    <div class="report-loader"></div>
                  </div>
                  <div class="went-wrong" *ngIf="videoNotFound">
                    <h3>Oops, Video not found!</h3>
                    <p>Please visit video section after sometime. If the issue persists, contact support.</p>
                  </div>
                  <div class="loader-container" *ngIf="updatingVideoUrl">
                    <div class="report-loader"></div>
                  </div>
                </div>

                <!-- Secondary Video (Video 2) -->
                <div class="video-session-wrapper" *ngIf="hasSecondVideo() && activeVideoSession === 2">
                  <ze-video id="video2" *ngIf="video_url_2 !== null" [filename]="video_url_2" [videoContent]="true"
                    [username]="user">
                  </ze-video>
                  <div class="loader-container" *ngIf="video_url_2 == null && !videoNotFound2 && !updatingVideoUrl2">
                    <div class="report-loader"></div>
                  </div>
                  <div class="went-wrong" *ngIf="videoNotFound2">
                    <h3>Oops, Video 2 not found!</h3>
                    <p>Please visit video section after sometime. If the issue persists, contact support.</p>
                  </div>
                  <div class="loader-container" *ngIf="updatingVideoUrl2">
                    <div class="report-loader"></div>
                  </div>
                </div>

              </div>
            </li>
            <li class="right_page_middle_report"
              *ngIf="(displayedContent === '' || (displayedContent === 'stepexecution' && (!hasLiveStatus(currentReport.report_links) || selectedBrowser === '' || selectedIteration === ''))) && currentReport._id != null">
              <div class="loader-container back">
                <!-- <div class="report-loader"></div> -->
                <ze-progress-loader [reportModel]="currentReport" *ngIf="currentReport && isExecutionWaiting(currentReport)"></ze-progress-loader>

              </div>
            </li>
            <li class="right_page_middle_report"
              *ngIf="displayedContent === 'aborted' || (currentReport.run_status_text == 'Aborted' && !hasLiveStatus(currentReport.report_links))">
              <div class="loader-container back">
                Execution Aborted
              </div>
            </li>
            <li class="right_page_middle_report" *ngIf="displayedContent === 'aborting' && currentReport._id != null">
              <div class="loader-container back">
                Execution Aborting...
              </div>
            </li>
            <li class="right_page_middle_report alert-container"
              *ngIf="(currentReport.run_status_text == 'Completed' || this.currentReport.run_status_text === 'Failed'|| currentReport.run_status_text === 'Execution Failed')  && !hasLiveStatus(currentReport.report_links)">
              <div class="went-wrong">
                <img src="../../../assets/images/alert.png" alt="Alert" class="alert-image">
                <h3>Oops, Something went wrong!</h3>
                <p>Please try again with new execution. If the issue persists, contact support.</p>
              </div>
            </li>
            <li class="right_page_middle_report alert-container" *ngIf="displayedContent === 'compilation_error'">
              <div class="went-wrong">
                <img src="../../../assets/images/alert.png" alt="Alert" class="alert-image">
                <h3>Compilation Error!</h3>
                <p>Please check your steps. If the issue persists, contact support.</p>
              </div>
            </li>
          </ul>
        </div>
      </ng-container>
      <ng-container *ngIf="currentReportLoading">
        <ze-loader class="current_report_loader"></ze-loader>
      </ng-container>
    </div>
  </div>
</section>
<ze-share-text-modal></ze-share-text-modal>